import { Cookies } from 'react-cookie';

import { BsTrapApiResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getBsTraps = async (slug: string, page: number, search?: string, ordering?: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/object/traps/bs/${slug}`, {
    headers: {
      Authorization: token,
    },
    params: {
      page,
      search,
      ordering,
    },
  });
  return data.data as BsTrapApiResponse;
};
